import styled from 'styled-components';

export const container = styled.div`
  display: flex;
  cursor: pointer;
  align-items: center;
  gap: var(--s2);
  user-select: none;

  &.reverse {
    flex-direction: row-reverse;
    width: 100%;
  }

  &.bottomLine {
    border-bottom: 1px solid var(--line);
  }
`;

export const box = styled.div`
  line-height: 0;
`;

export const Div = styled.p`
  font-size: var(--fs-body);
  font-weight: var(--fw-regular);
  color: var(--text);

  &.active {
    font-weight: var(--fw-medium);
  }
`;

export const icon = styled.div`
  width: 15px;
  height: 15px;
  line-height: 0;

  &.two {
    width: 15px;
    height: 15px;
  }
`;

export const Input = styled.input`
  width: 15px;
  height: 15px;
  margin: 0;
  padding: 0;
  background: var(--surface);
  border: 1.5px solid var(--line-strong);
  border-radius: 4px;
  -webkit-appearance: none;
  appearance: none;
  cursor: pointer;
  transition:
    background-color 0.12s,
    border-color 0.12s;

  &.two {
    width: 15px;
    height: 15px;
    border: 1.5px solid var(--line-strong);
  }

  &:hover {
    border-color: var(--text-faint);
  }

  &.checked {
    background-image: url('/icons/check-white.svg');
    background-color: var(--primary);
    border-color: var(--primary);
    background-position: center;
    background-repeat: no-repeat;
    background-size: 10px;
  }
`;
